import React from "react";
import { Toast, IconClose , TOAST_VARIANTS, Loader }  from 'cdk-radial'

export const InlineToastNotification = ({
  visible,
  message,
  variant = TOAST_VARIANTS.NEUTRAL,
  onClose,
  showCloseButton = true,
}) => {
  if (!visible) return null;

  return (
    <Toast
      content={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <span>{message}</span>
          {showCloseButton && (
            <IconClose
              onClick={onClose}
              height={24}
              width={24}
              data-testid="toast-close-icon"
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      }
      variant={variant}
      style={{
        padding: '0px 0px 16px 0px',
        zIndex: '5',
      }}
    />
  );
};

export const LoaderToast = ({
  visible,
  message = 'Fetching Order Details.',
  loadingText = 'Your API order is updating and will be ready soon.',
}) => {
  if (!visible) return null;

  return (
    <div className="fetching-api-details-custom-toast-container">
      <div className="fetching-api-details-loader">
        <Loader />
      </div>
      <div className="fetching-api-details-loader-text">
        {loadingText || message}
      </div>
    </div>
  );
};
